var BundleProductCheckout = (function () {
  var config;
  function mount() {
    document.querySelectorAll('[data-bundle-checkout]').forEach(function (box) {
      if (box.dataset.mounted) { box.refreshBundle(); return; }
      box.dataset.mounted = 'true';
      var form = box.closest('form');
      var component = box.closest('product-form-component');
      var nativeButton = form.querySelector('.accelerated-checkout-block');
      var addToCart = form.querySelector('add-to-cart-component');
      var addToCartHidden = addToCart && addToCart.hidden;
      var button = box.querySelector('[data-bundle-buy]');
      var status = box.querySelector('[data-bundle-status]');
      var loadedId, variant;
      var selections = {};
      var busy = false;
      var generation = 0;
      box.invalidateBundle = function () {
        loadedId = null;
        variant = null;
        generation++;
        button.disabled = true;
        component.dataset.bundleCheckoutState = 'pending';
        if (nativeButton) nativeButton.hidden = true;
      };
      function refresh() {
        var id = form.querySelector('[name="id"]').value;
        if (id === loadedId) return;
        loadedId = id;
        var current = ++generation;
        variant = null;
        selections = {};
        component.dataset.bundleCheckoutState = 'pending';
        if (nativeButton) nativeButton.hidden = true;
        box.hidden = false;
        button.disabled = true;
        status.textContent = box.dataset.loading;
        SubscriptionCheckoutPage.loadBundleVariant('gid://shopify/ProductVariant/' + id, config).then(function (result) {
          if (current !== generation || !box.isConnected) return;
          if (!result.requiresComponents && !result.components.nodes.length) {
            component.dataset.bundleCheckoutState = 'false';
            box.hidden = true;
            if (nativeButton) nativeButton.hidden = !result.availableForSale;
            if (addToCart) addToCart.hidden = addToCartHidden;
            return;
          }
          var hasSellingPlan = result.components.nodes.some(function (entry) {
            return entry.productVariant.sellingPlanAllocations.nodes.length > 0;
          });
          if (!hasSellingPlan) {
            component.dataset.bundleCheckoutState = 'false';
            box.hidden = true;
            if (nativeButton) nativeButton.hidden = !result.availableForSale;
            if (addToCart) addToCart.hidden = addToCartHidden;
            return;
          }
          component.dataset.bundleCheckoutState = 'true';
          if (addToCart) addToCart.hidden = true;
          variant = result;
          result.components.nodes.forEach(function (entry) {
            var child = entry.productVariant;
            var plans = child.sellingPlanAllocations.nodes;
            if (!plans.length) return;
            selections[child.id] = plans[0].sellingPlan.id;
          });
          status.textContent = '';
          button.disabled = !result.availableForSale;
        }).catch(function () {
          if (current !== generation || !box.isConnected) return;
          status.textContent = box.dataset.error;
          button.disabled = false;
          loadedId = null;
        });
      }
      button.addEventListener('click', async function () {
        if (busy) return;
        if (!variant || variant.id !== 'gid://shopify/ProductVariant/' + form.querySelector('[name="id"]').value) {
          refresh();
          return;
        }
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = box.dataset.loading;
        try {
          var quantityInput = form.querySelector('[name="quantity"]');
          var lines = SubscriptionCheckoutPage.buildBundleLines(variant, quantityInput ? Number(quantityInput.value) : 1,
            selections, crypto.randomUUID());
          var url = await SubscriptionCheckoutPage.createCheckoutUrl({ lines: lines, email: config.email() }, config);
          window.location.assign(url);
        } catch (error) {
          status.textContent = box.dataset.error + ' ' + error.message;
          busy = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
      form.addEventListener('change', refresh);
      box.refreshBundle = refresh;
      refresh();
    });
  }
  function start(cfg) {
    config = cfg;
    document.addEventListener('variant:selected', function (event) {
      var section = event.target.closest('section');
      if (!section) return;
      section.querySelectorAll('[data-bundle-checkout]').forEach(function (box) {
        if (box.invalidateBundle) box.invalidateBundle();
      });
    });
    document.addEventListener('variant:update', function () { setTimeout(mount, 0); });
    document.addEventListener('shopify:section:load', mount);
    mount();
  }
  return { start: start };
})();
